import { ReactNode } from "react";

// routes
import {
  PATH_ASSET,
  PATH_ASSET_INDEX,
  PATH_ADMIN,
  PATH_BACKTEST,
  PATH_ETF,
  PATH_FUND,
  PATH_REALTY,
  PATH_STOCK,
} from "../../routes/paths";

// components
import { getIcon } from "@components/asset/SvgIconStyle";
import { PERMISSIONS, Permission } from "@auth";

// ----------------------------------------------------------------------


const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  analytics: getIcon("ic_analytics"),
  stack: getIcon("ic_elements"),
  page: getIcon("ic_page"),
  monitor: getIcon("ic_kanban"),
  calendar: getIcon("ic_calendar"),
  performance: getIcon("ic_dashboard"),
  cart: getIcon("ic_cart"),
  pieChart: getIcon("ic_charts"),
  components: getIcon("ic_components"),
};

type NavChild = { title: string; path: string };

type NavItem = {
  title: string;
  path: string;
  icon?: ReactNode;
  /** 있으면 이 권한을 가진 사용자에게만 메뉴가 보인다. 판정은 DashboardSidebar 가 한다. */
  permission?: Permission;
  children?: NavChild[];
};

type NavSection = { subheader: string; items: NavItem[] };

const sidebarConfig: NavSection[] = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "데이터",
    items: [
      {
        title: "ETF 데이터",
        path: PATH_ETF.root,
        icon: ICONS.stack,
      },
      {
        title: "주식 데이터",
        path: PATH_STOCK.root,
        icon: ICONS.stack,
      },
      {
        title: "펀드 데이터",
        path: PATH_FUND.root,
        icon: ICONS.stack,
        children: [
          { title: "국내", path: PATH_FUND.kr },
        ],
      },
      {
        // develop 에서도 Macro / MSCI / MSCI Band 는 주석 상태다. Global 만 옮겼다.
        title: "지수 데이터",
        path: PATH_ASSET.index_asset,
        icon: ICONS.stack,
        children: [
          { title: "Global", path: PATH_ASSET_INDEX.global },
        ],
      },
      {
        // 업데이트가 멈춰 있어 elite 전용으로 돌린다 (정재영님 요청 B).
        // 서버도 `require(realty.view)` 로 막으므로 URL 을 직접 쳐도 403 이다.
        title: "부동산 데이터",
        path: PATH_REALTY.root,
        icon: ICONS.stack,
        permission: PERMISSIONS.REALTY_VIEW,
        children: [
          { title: "지수", path: PATH_REALTY.index },
        ],
      },
    ],
  },
  {
    subheader: "분석",
    items: [
      {
        title: "백테스트",
        path: PATH_BACKTEST.root,
        icon: ICONS.analytics,
        children: [
          { title: "정적 전략 백테스트", path: PATH_BACKTEST.staticBacktest },
        ],
      },
    ]
  },
  {
    subheader: "관리",
    items: [
      {
        // `permission` 이 있으면 그 권한을 가진 사람에게만 보인다 (DashboardSidebar 가 거른다).
        // 메뉴에서 감추는 것만으로는 URL 을 직접 치면 열리므로 라우트도 같은 권한으로 감쌌고,
        // 서버도 `require_level(ADMIN)` 으로 따로 막는다.
        title: "관리자",
        path: PATH_ADMIN.users,
        icon: ICONS.user,
        permission: PERMISSIONS.ADMIN_PANEL,
        children: [
          { title: "유저 관리", path: PATH_ADMIN.users },
          { title: "멤버십 관리", path: PATH_ADMIN.memberships },
        ],
      },
    ],
  },
];

export default sidebarConfig;
